import authAxios, { authHeader } from "../data";
import qs from "qs";

const fetchAccounts = async (request: any) => {
  const response = await authAxios.get("/api/Accesses", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const fetchAccountsCount = async (request: any) => {
  const response = await authAxios.get("/api/Accesses/count", {
    params: request,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    headers: authHeader(),
  });

  return response.data;
};

const fetchAccountContracts = async (contractNumber: string) => {
  const response = await authAxios.get(
    `/api/Accesses/contracts/${contractNumber}`,
    { headers: authHeader() },
  );

  return response.data;
};

const AccountsService = {
  fetchAccounts,
  fetchAccountsCount,
  fetchAccountContracts,
};

export default AccountsService;
